export default class HadrianBase {
  id: string;
}
